<script lang="ts">
	interface Props {
		background?: string;
		padding?: string;
		border?: string;
		children?: import('svelte').Snippet;
	}

	let {
		background = '',
		padding = 'p-5',
		border = 'border border-primary-500/50',
		children
	}: Props = $props();
</script>

<div class="{background} {padding} {border} rounded-container">
	{@render children?.()}
</div>
